<template>
	<div id="developerIndex">
		<div class="wrap container-fluid">
			<div class="row">
				<div class="menu_left">
					<div class="menu_top">
						<!--<img src="" alt="" />-->
						<p class="text-center" v-if="this.$store.getters.getUserType == '101005' || this.$store.getters.getUserType == '101006'">
							<router-link to="/app_index">
								<img src="./assets/images/logo-register-info.png" alt="" />
							</router-link>
						</p>
						<p class="text-center" v-if="this.$store.getters.getUserType == '101009'">
							<router-link to="/manage_app">
								<img src="./assets/images/logo-register-info.png" alt="" />
							</router-link>
						</p>
						<p class="text-center" v-if="this.$store.getters.getUserType == '101005' || this.$store.getters.getUserType == '101006'">开发者管理中心</p>
						<p class="text-center" v-if="this.$store.getters.getUserType == '101009'">平台管理中心</p>
					</div>
					<div class="menu_btm">
						<div class="tree_wrap">
							<div class="tree_box manage_list user-select">
								<h5>
									应用管理
								</h5>
								<ul class="tree_one">
									<li v-if="this.$store.getters.getUserType == '101005' || this.$store.getters.getUserType == '101006'">
										<span class="line"></span>
										<router-link to="/all_app">所有应用</router-link>
									</li>
									<li v-if="this.$store.getters.getUserType == '101005' || this.$store.getters.getUserType == '101006'">
										<span class="line"></span>
										<router-link to="/publish_apply">发布应用</router-link>
									</li>
									<li v-if="this.$store.getters.getUserType == '101009'">
										<span class="line"></span>
										<router-link to="/manage_app">应用审核</router-link>
									</li>
									<li v-if="this.$store.getters.getUserType == '101009'">
										<span class="line"></span>
										<router-link to="/service_school">维护校园信息</router-link>
									</li>
								</ul>
							</div>
							
							<div class="tree_box order_list user-select">
								<h5>
									订单管理
								</h5>
								<ul class="tree_one">
									<li v-if="this.$store.getters.getUserType == '101005' || this.$store.getters.getUserType == '101006'">
										<span class="line"></span>
										<router-link to="/order_list">订购列表</router-link>
									</li>
									<li v-if="this.$store.getters.getUserType == '101009'">
										<span class="line"></span>
										<router-link to="/manager_order_list">订购列表</router-link>
									</li>
								</ul>
							</div>
							
							<div class="tree_box feedback_list user-select" v-if="this.$store.getters.getUserType == '101009'">
								<h5>
									<router-link to="/feedback_list">用户反馈</router-link>
								</h5>
							</div>
						</div>
					</div>
				</div>
				<div class="container_right">
					<div class="container_right_info">
						<section class="menu_right_title text-right">
							<section class="message" v-if="this.$store.getters.getUserType == '101005' || this.$store.getters.getUserType == '101006'">
								<i class="glyphicon dropdown-toggle icon_message cursor" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<!--消息数量提示-->
									<span class="message_num text-center" :class="[this.$store.getters.getMCount == 0 ? 'hide' : 'show']">{{this.$store.getters.getMCount | msgNum}}</span>
								</i>
								<dl class="message_box fade text-left word-bw dropdown-menu">
									<dt>
										<span class="text-left">消息通知</span>
										<span class="text-right cursor">
											<router-link to="/message_list" class="message_all">全部消息</router-link>
										</span>
									</dt>
									<dd v-if="this.$store.getters.getMCount == 0">
										<p>暂无消息</p>
									</dd>
									<dd v-else v-for="ms in this.$store.getters.getMessageTopList.content" @click="viewMDetail(ms.id)" style="cursor: pointer;">
										<p>{{ms.messageTitle}}</p>
										<p>
											<small class="message_color">{{ms.messageSendTime | datetime}}</small>
										</p>
									</dd>
								</dl>
							</section>
							<section class="message_user">
								<!--<router-link to="/head_portrait">-->
								<i class="ico_head_portrait cursor"></i>
								<!--</router-link>-->
								<span class="user_message dropdown-toggle cursor" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									账户信息
									<i class="caret"></i>
								</span>
								<ul class="user_list text-center dropdown-menu">
									<li v-if="this.$store.getters.getUserType == '101005'" id="elIndex">
										<!--<a href="javascript:;">平台首页</a>-->
										<router-link to="/app_index">平台首页</router-link>
									</li>
									<li v-if="this.$store.getters.getUserType == '101005'" id="elDeveloperData">
										<router-link to="/developer_data">开发者资料(个人)</router-link>
									</li>
									<li v-if="this.$store.getters.getUserType == '101006'" id="elIndexCompany">
										<router-link to="/app_index">平台首页</router-link>
									</li>
									<li v-if="this.$store.getters.getUserType == '101006'" id="elCompanyDeveloperData">
										<router-link to="/company_data">开发者资料(企业)</router-link>
									</li>
									<li id="elUpdatePwd">
										<router-link to="/change_password">修改密码</router-link>
									</li>
									<li id="elLogOut">
										<a href="javascript:void(0);" @click="logout()">退出登录</a>
									</li>
								</ul>
							</section>
						</section>
						<section class="container_btm">
							<router-view></router-view>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'developerIndex',
		data() {
			return {
				showOne: false,
				showTwo: false,
				websocketServer: ''
			}
		},
		beforeCreate: function(){
			if(this.$store.getters.getUserType == '101009'){
				this.$router.push({path:'/manage_app'});
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				this.rightHeight();
				window.onresize=this.rightHeight;
				this.offList();
				//初始化获取用户类型信息
				this.queryUserType();
				
				//menu 
				$(".tree_box").find("li a").click(function(){
					$(".tree_box").find("li").removeClass("active");
					$(this).parent().addClass("active")
				})
			})
		},
		methods: {
			rightHeight() {
				var winHeight = 0;
				if(window.innerHeight){
					winHeight = window.innerHeight;
				}else if((document.body) && (document.body.clientHeight)){
					winHeight = document.body.clientHeight;
				}
				if(document.documentElement && document.documentElement.clientHeight) {
					winHeight = document.documentElement.clientHeight;
				}
				var indexHeight = $(".menu_left").height();
				$(".container_right").css("min-height", winHeight);
			},
			logout() {
				this.$router.push({ path: '/login' })
			},
			viewMDetail(id) {
				this.$router.push({ name: 'read_message', params: { messageId: id } });
			},

			queryUserType() { //获取用户类型信息
				var temp = this;
				this.$http.post('/zklccloud/findTCloudUser', { emulateJSON: true }).then(function(m) {
					/*if(m.body.content.userInfo == null){//说明无角色
						this.$router.replace('/register_success1');
					}*/
					temp.websocketServer = m.body.content.websocketServer;
					
					var dictCode = new String(m.body.content.userId);

					var userType = new String(m.body.content.userInfo.userType);

					if(userType.indexOf(',') == -1) {
						temp.$store.dispatch('setMessageTopList', userType);
						temp.$store.dispatch('setMCount', userType);
						if(userType == '101009') {
							temp.$store.dispatch('setUserType', userType);
							temp.$router.replace('/manage_app');
						} else if(userType == '101005' || userType == '101006') {
							temp.$store.dispatch('setUserType', userType);
						} else {

						}
					} else {
						temp.$store.dispatch('setUserType', m.body.content.userInfo.userType)
					}
					
					temp.xiaoxi(dictCode);
				})
			},
			xiaoxi(obj) {
				var temp = this;
				//实现化WebSocket对象，指定要连接的服务器地址与端口
				var socket = new WebSocket(this.websocketServer + "?dictCode=" + obj);
				//打开事件
				socket.onopen = function() {
					//alert("Socket 已打开");
					//socket.send("这是来自客户端的消息" + location.href + new Date());
				};
				//获得消息事件
				socket.onmessage = function(msg) {
					var loginType = temp.$store.getters.getUserType;
					temp.$store.dispatch('setMessageTopList', loginType);
					temp.$store.dispatch('setMCount', loginType);
				};
				//关闭事件
				socket.onclose = function() {
					//alert("Socket已关闭");
				};
				//发生了错误事件
				socket.onerror = function() {
					//alert("发生了错误");
				}
			}
		}
	}
</script>

<style scoped>
	.tree_one {
		background-color: #445078;
	}

</style>


// WEBPACK FOOTER //
// developer_index.vue?5bee060d